import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';

import { trackEvent } from '../index';

import type { ValueOf } from 'type-fest';
import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const VIEW_DASHBOARD_TAB_EVENT_ID = '6043';
export const VIEW_RESTRICTED_LISTING_BANNER_EVENT_ID = '7544';
export const CLICK_CONTACT_SUPPORT_FROM_RESTRICTED_BANNER_EVENT_ID = '7545';

export const BLOCKED_LISTING_TRIGGER_OBJECTS = {
  VERIFY_LISTING: 'verify_your_listing',
  VERIFICATION_LISTING: 'verification_of_your_listing',
  CONTACT_SUPPORT: 'contact_support',
} as const;

// https://dataportal.zillowgroup.net/event-registry/6043
export const emitViewDashboardTabEvent = ({
  user,
  triggerLocationNm,
  triggerSourceNm,
}: {
  user: ZrmClickstreamUser | null;
  triggerLocationNm: string;
  triggerSourceNm: string;
}) =>
  trackEvent.user({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: VIEW_DASHBOARD_TAB_EVENT_ID,
      event_type_version_id: '3',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocationNm,
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: triggerSourceNm,
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7544
export const emitViewRestrictedListingBannerEvent = ({
  user,
  currentProperty,
  triggerLocation,
}: {
  user: ZrmClickstreamUser | null;
  currentProperty: ZrmClickstreamListing;
  triggerLocation: 'posting_path_review' | 'zrm_property_overview';
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: VIEW_RESTRICTED_LISTING_BANNER_EVENT_ID,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_blocked_listing_banner',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_account_verification'],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(currentProperty),
  });

// https://dataportal.zillowgroup.net/event-registry/7545
export const emitClickContactSupportFromRestrictedBannerEvent = ({
  user,
  currentProperty,
  triggerLocation,
  triggerObject,
}: {
  user: ZrmClickstreamUser | null;
  currentProperty: ZrmClickstreamListing;
  triggerLocation: 'posting_path_review' | 'zrm_property_overview';
  triggerObject: ValueOf<typeof BLOCKED_LISTING_TRIGGER_OBJECTS>;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: CLICK_CONTACT_SUPPORT_FROM_RESTRICTED_BANNER_EVENT_ID,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: 'link_to_contact_support_blocked_banner',
    },
    semantic: {
      semantic_event_nm: 'click_contact_support',
      topic_tag_txt: ['zrm_account_verification'],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(currentProperty),
  });
